import Common from '../common';

const MovingMyPoint = {
  /**
   * クリックしたマイマーカーの半径0.5m以内にあるマーカー
   */
  RADIUS: 0.5, // Meters
  /**
   * Google Maps Platform
   */
  google: null,
  /**
   * 地図
   */
  map: null,
  /**
   * Vue Map Google
   */
  vueMapGoogle: null,
  /**
   * Display map in moving my point mode or not
   */
  mode: false,
  /**
   * Display map in destination select mode or not
   */
  destinationMode: false,
  /**
   * Marker
   */
  marker: null,
  /**
   * Moving points
   */
  points: [],
  /**
   * Destination lat, lon
   */
  destination: null,
  /**
   * 初期化
   *
   * @param mapModule
   * @param google
   * @param map
   * @param vueMapGoogle
   */
  init(mapModule, google, map, vueMapGoogle) {
    const self = this;
    return new Promise((resolve) => {
      self.mapModule    = mapModule;
      self.google       = google;
      self.map          = map;
      self.vueMapGoogle = vueMapGoogle;
      self.clearMarker();
      self.setMode(false);
      self.setDestinationMode(false);
      self.map.addListener('click', function (event) {
        if (!self.getMode()) {
          return;
        }
        self.setMarker(event.latLng);
      });
      return resolve();
    });
  },
  /**
   * Set in moving my point mode
   *
   * @param mode
   */
  setMode(mode) {
    this.mode = mode;
    if (this.mode) {
      this.reloadRegistrations();
    } else {
      this.exit();
    }
    return this;
  },
  /**
   * Set destination select mode
   *
   * @param mode
   */
  setDestinationMode(mode) {
    this.destinationMode = mode;
    this.reloadRegistrations();
  },
  /**
   * Get in moving my point mode
   *
   * @returns {boolean}
   */
  getMode() {
    return this.mode;
  },
  /**
   * Get in destination select mode
   *
   * @returns {boolean}
   */
  getDestinationMode() {
    return this.destinationMode;
  },
  /**
   * Set in moving my point mode
   *
   * @param points
   * @return {MovingMyPoint}
   */
  setPoints(points) {
    this.points = points;
    this.redrawPdfMarker();
    return this;
  },
  /**
   * Change selected list by id
   *
   * @param pointId
   * @param checkValue
   */
  selectedChange(pointId, checkValue) {
    for (let index = 0; index < this.points.length; index++) {
      if (pointId === this.points[index].id) {
        this.points[index].checked = checkValue;
        this.redrawPdfMarker();
        return;
      }
    }
  },
  /**
   * Push a point to the list
   *
   * @param point
   * @return {MovingMyPoint}
   */
  push(point) {
    let targetIndex = -1;
    for (let index = 0; index < this.points.length; index++) {
      if (point.id === this.points[index].id) {
        targetIndex = index;
        break;
      }
    }
    if (targetIndex >= 0) {
      this.points[targetIndex].checked = false;
    } else {
      this.points.push(Object.assign({checked: false}, point));
    }
    if (this.vueMapGoogle) {
      this.vueMapGoogle.$emit('updateMovingPoints', this.points);
    }
    return this;
  },
  /**
   * Get all my point to move
   */
  getPoints() {
    return this.points;
  },
  /**
   * Get the destination point
   */
  getDestination() {
    return this.destination;
  },
  /**
   * @param position
   */
  setMarker(position) {
    const self = this;
    if (this.mapModule && this.mapModule.getIsLongPress()) {
      return;
    }
    if (!this.getMode() || !this.getDestinationMode()) {
      return
    }
    self.destination = position;
    if (self.marker !== null) {
      self.marker.setPosition(self.destination);
      return;
    }
    self.marker = new this.google.maps.Marker({
      map      : this.map,
      draggable: true,
      position : position,
      icon     : this.icon,
      title    : Common.messages.movingMarkerTitle,
      animation: this.google.maps.Animation.BOUNCE,
      zIndex   : 2
    });
    self.marker.addListener('click', function () {
      self.clearMarker();
    });
    self.marker.addListener('dragend', function (event) {
      self.destination = event.latLng;
    });
  },
  /**
   * Remove marker
   */
  clearMarker() {
    if (this.marker) {
      this.marker.setMap(null);
      this.marker = null;
    }
    this.destination = null;
  },
  /**
   * Reload registrations
   */
  reloadRegistrations() {
    if (this.mapModule) {
      this.mapModule.getPdfRegistration(this.vueMapGoogle);
    }
  },
  /**
   * Reload registrations
   */
  redrawPdfMarker() {
    if (this.mapModule) {
      this.mapModule.drawPdfMarkers(this.vueMapGoogle, true);
    }
  },
  /**
   * Exit moving my points mode
   */
  exit() {
    this.clearMarker();
    this.points = [];
    this.reloadRegistrations();
  },
}

export default MovingMyPoint;